import React from 'react';
import { useTranslation } from 'react-i18next';
import { BsEnvelope, BsLock } from 'react-icons/bs';
import { useFormik } from 'formik';
import ContentCard from '../../../../../../../../../../../components/content/ContentCard';
import { FormInput } from '@omnigenbiodata/ui';

export interface EmailFormProps {
  email: any;
  onSubmit: (values: any) => void;
}

function EmailForm({ email, onSubmit }: EmailFormProps) {
  const { t } = useTranslation('portal');
  const formik = useFormik({
    initialValues: {
      email: (email as string) || '',
    },
    enableReinitialize: true,
    onSubmit: (values: any) => {
      onSubmit(values);
    },
  });

  return (
    <ContentCard>
      <form onSubmit={formik.handleSubmit}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <FormInput
            startAdornment={<BsEnvelope fontSize={20} style={{ marginRight: 10 }} />}
            endAdornment={<BsLock fontSize={20} style={{ marginLeft: 10 }} />}
            margin="none"
            error={formik.errors.email}
            name="email"
            label={t('email', { ns: 'forms' })}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            touched={formik.touched.email}
            value={formik.values.email}
            disabled
          />
        </div>
      </form>
    </ContentCard>
  );
}

export default EmailForm;
